import React from 'react';
import { FormattedMessage } from 'react-intl';

import { insuranceShape } from 'constants/propTypes';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Row, Column } from 'components/shared/Layout';

const ExtrasInsurance = ({ insurance }) => {
  const { passenger, policyNumber, date, description, currency, price } = insurance;

  return (
    <div data-cy="extras-insurance">
      <Row>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.passenger" />
          </strong>
          {passenger && (
            <div>
              {passenger.firstName} {passenger.lastName}
            </div>
          )}
        </Column>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.insurance.date" />
          </strong>
          <div>{date}</div>
        </Column>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.insurance.policyNumber" />
          </strong>
          <div>{policyNumber}</div>
        </Column>
        <Column span={5}>
          <strong>
            <FormattedMessage id="extras.insurance.description" />
          </strong>
          <div>{description}</div>
        </Column>
        <Column span={2}>
          <strong>
            <FormattedMessage id="extras.total" />
          </strong>
          <div>
            <FormattedCurrency currency={currency} amount={price} />
          </div>
        </Column>
      </Row>
      <hr />
    </div>
  );
};

ExtrasInsurance.propTypes = {
  insurance: insuranceShape
};

export default ExtrasInsurance;
